import type React from 'react';
import { BORDERS, SPACING } from '../../../../constants/design';
import { useColors } from '../../../../contexts/ThemeContext';

interface LayoutWidthPreviewProps {
  width: 'fluid' | 'container';
  size?: number;
}

export const LayoutWidthPreview: React.FC<LayoutWidthPreviewProps> = ({ width, size = 48 }) => {
  const tokens = useColors();

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        padding: SPACING.xs,
        border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
        borderRadius: BORDERS.radius.sm,
        background: tokens.surface.container,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: width === 'fluid' ? '100%' : '70%',
          height: '65%',
          background: tokens.primary[100],
          borderRadius: BORDERS.radius.sm,
          border: `${BORDERS.width.thin} solid ${tokens.primary[400]}`,
        }}
      />
    </div>
  );
};
